import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  delay = 0
}: SectionProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay
  }} className={`py-8 md:py-14 px-4 md:px-8 max-w-5xl mx-auto ${className}`} data-id="element-119">
      {children}
    </motion.section>;
}